// extracted by mini-css-extract-plugin
export default {"box":"BankAccountBox_box__HL3sl"};